import type * as React from "react";
import { Box, ButtonBase, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { trackDashboardCtaClicked } from "analytics";
import NewToDoIcon from "assets/icons/new-to-do.svg";
import { COLORS } from "components/v3/Theme/colors";
import { PATHS } from "constants/pathConstants";
import Translate from "translate/Translate";

const headline = "See what actions are suggested for you!";
const message =
  "Get the most out of your Genomic Life membership. This list of next steps is curated just for you—so you don't miss out on any benefits.";

const SuggestedActionsDashboardBar: React.FC = () => {
  return (
    <Box sx={{ display: "flex", flex: 1, minWidth: 0, width: "100%" }}>
      <ButtonBase
        aria-label={`${headline}. ${message}`}
        component={RouterLink}
        data-testid="suggested-actions-dashboard-bar"
        focusRipple
        onClick={() => {
          trackDashboardCtaClicked({
            workflow: "dashboard",
            ctaLocation: "dashboard_card",
            ctaId: "your_next_steps"
          });
        }}
        to={PATHS.YOUR_NEXT_STEPS}
        sx={{
          alignItems: "stretch",
          backgroundColor: COLORS.ACCENT3_LIGHTER,
          borderRadius: "8px",
          boxSizing: "border-box",
          display: "block",
          height: "100%",
          overflow: "hidden",
          position: "relative",
          textAlign: "left",
          textDecoration: "none",
          transition: "filter 0.2s ease",
          width: "100%",
          "&:hover": {
            filter: "brightness(0.98)"
          },
          "&:focus-visible": {
            outline: `2px solid ${COLORS.ACCENT3_DARK}`,
            outlineOffset: 2
          }
        }}
      >
        <Box
          aria-hidden
          sx={{
            height: 72,
            left: 0,
            overflow: "hidden",
            pointerEvents: "none",
            position: "absolute",
            top: 0,
            width: 72
          }}
        >
          <Box
            sx={{
              backgroundColor: COLORS.ACCENT3_DARK,
              left: "33%",
              position: "absolute",
              py: 0.375,
              textAlign: "center",
              top: 11,
              transform: "translateX(-50%) rotate(-45deg)",
              width: 96
            }}
          >
            <Typography
              component="span"
              sx={{
                color: COLORS.WHITE,
                fontSize: "14px",
                fontWeight: 700,
                letterSpacing: "0.04em",
                lineHeight: 1
              }}
            >
              NEW!
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            gap: { md: 2.5, xs: 2 },
            pl: { md: 6, xs: 5 },
            pr: 3,
            py: 3
          }}
        >
          <Box
            alt=""
            component="img"
            src={NewToDoIcon}
            sx={{
              display: "block",
              flexShrink: 0,
              height: 76,
              ml: "-5px",
              width: "auto"
            }}
          />
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            <Typography
              component="h2"
              variant="body_strong_lg_black"
              sx={{ margin: 0 }}
            >
              <Translate text={headline} />
            </Typography>
            <Typography component="p" sx={{ margin: 0 }} variant="body">
              <Translate text={message} />
            </Typography>
          </Box>
        </Box>
      </ButtonBase>
    </Box>
  );
};

export default SuggestedActionsDashboardBar;
